import React from "react";
import { useAdminContext } from "../provider/AdminContext";
import DrilldownHeader from "./DrilldownHeader";

const formatDate = (dateString) => {
  if (!dateString) return "N/A";
  return new Date(dateString).toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
};

const formatUser = (user) =>
  user ? `${user.firstName} ${user.lastName}` : "N/A";

const MappingsGrid = () => {
  const { selectedCompany, selectedProject, projectMappings } =
    useAdminContext();

  return (
    <div className="w-full h-full overflow-y-auto">
      <div className="bg-gray-50 p-3 sm:p-4 md:p-6">
        <div className="max-w-5xl mx-auto">
          <DrilldownHeader
            title={`Mappings - ${selectedProject?.projectName || ""}`}
            breadcrumbs={[
              "All Companies",
              selectedCompany?.companyName,
              "Projects",
            ]}
          />

          {projectMappings.length === 0 ? (
            <div className="bg-white rounded-lg shadow-md border border-gray-200 p-8 text-center text-sm text-gray-500">
              No mappings found for this project.
            </div>
          ) : (
            <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
              {projectMappings.map((mapping) => {
                const wasUpdated =
                  mapping.updatedBy &&
                  new Date(mapping.updatedAt).getTime() !==
                    new Date(mapping.createdAt).getTime();

                return (
                  <div
                    key={mapping._id}
                    className="bg-white rounded-lg shadow-md border border-gray-200 p-6"
                  >
                    <h2 className="text-lg font-semibold text-gray-900 mb-2">
                      {mapping.mappingName}
                    </h2>
                    <p className="text-sm text-gray-500">
                      Created by {formatUser(mapping.createdBy)} on{" "}
                      {formatDate(mapping.createdAt)}
                    </p>
                    {wasUpdated && (
                      <p className="text-sm text-gray-500 mt-1">
                        Updated by {formatUser(mapping.updatedBy)} on{" "}
                        {formatDate(mapping.updatedAt)}
                      </p>
                    )}
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MappingsGrid;
